<div class="container w-full h-full overflow-hidden">
  <header class="header modal-header flex flex-col gap-2 place-content-between">
    <!-- /Logo Box -->
    <div class="flex flex-col place-content-center">
      <a class="h-full w-full flex flex-col justify-center items-center" rel="noopener">
        <img class="login-company-logo" src="assets/logos/brand-logo.svg" alt="VKB" />
      </a>
    </div>
  </header>
  <div class="body w-full py-4 px-8" [innerHTML]="vkbTermsAndConditions"></div>
  <div class="footer w-full py-2 px-8">
    <div class="right-actions float-right inline-block pt-2 pb-6 px-5">
      <button type="submit" mat-flat-button class="w-auto button-primary inline-flex gap-1 icon-right" (click)="acceptTnC()">
        <span>Akzeptieren</span>
      </button>
    </div>
  </div>
</div>
